import React, { useEffect } from 'react';
import './style.scss';
import { IconColor, IconSize, SvgIcon } from '../svgIcon';
import { IconName, findIcon } from 'utils/handleIcon';

export type SearchSelectProps = {
  disabledOption?: string;
  options?: string[];
  selectedOption: string;
  setSelectedOption: (selectedOption: string) => void;
};

// TODO:口座開設のSelectBoxと検索欄のセレクトボックスはコンポーネントを分ける
export const SearchSelect = (props: SearchSelectProps) => {
  const { options, selectedOption, setSelectedOption, disabledOption } = props;

  const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedOption(event.target.value);
  };

  const icon = findIcon(IconName.arrow);

  return (
    <div className="searchArrow">
      <SvgIcon icon={icon} size={IconSize.icon_m} color={IconColor.primary} />
      <select className="searchSelect" value={selectedOption} onChange={handleSelect}>
        {/* TODO:初期値に検索内容のテキストを流す */}
        <option selected disabled style={{ color: '#737373' }}>
          {disabledOption}
        </option>
        {options?.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};
